import React, { useRef } from 'react';
import P from 'prop-types';
import './styles.css';

export const OtpInput = ({ length = 6, value = '', onChange, disabled = false }) => {
  const refs = useRef([]);

  const digits = Array.from({ length }, (_, i) => value[i] || '');

  const focus = (i) => {
    if (i < 0 || i >= length) return;
    refs.current[i]?.focus?.();
    refs.current[i]?.select?.();
  };

  const setDigit = (i, ch) => {
    if (disabled) return;
    if (ch && !/^[0-9]$/.test(ch)) return;
    const arr = value.split('');
    while (arr.length < length) arr.push('');
    arr[i] = ch || '';
    onChange(arr.join('').slice(0, length));
    if (ch && i < length - 1) focus(i + 1);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    if (disabled) return;
    const nums = (e.clipboardData.getData('text') || '').replace(/\D/g, '').slice(0, length);
    if (!nums) return;
    onChange(nums);
    focus(Math.min(nums.length, length - 1));
  };

  return (
    <div className="otp-row" role="group" aria-label="Código SMS">
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          className="otp-box"
          type="text"
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          value={d}
          disabled={disabled}
          onChange={(e) => setDigit(i, e.target.value.replace(/\D/g, '').slice(-1))}
          onKeyDown={(e) => {
            if (e.key === 'Backspace' && !digits[i] && i > 0) focus(i - 1);
            if (e.key === 'ArrowLeft' && i > 0) focus(i - 1);
            if (e.key === 'ArrowRight' && i < length - 1) focus(i + 1);
          }}
          onPaste={handlePaste}
          onFocus={(e) => e.target.select?.()}
          aria-label={`Dígito ${i + 1}`}
        />
      ))}
    </div>
  );
};

OtpInput.propTypes = {
  length: P.number,
  value: P.string,
  onChange: P.func.isRequired,
  disabled: P.bool,
};
